import {AppliedDiscount, AppliedDiscountDiscountType} from '@wix/auto_sdk_ecom_current-cart';
import {Discount, DiscountSourceType, DiscountScope, DiscountScopeWithLiterals} from '@wix/auto_sdk_ecom_cart-v-2';
import {ModelContext} from '../../../types/app.types';
import {SPECS} from '../../specs';

export class CouponDiscountModel {
  public scope: CouponDiscountScope;
  public totalAmountOff: string;
  public targetLineItemIds: string[];
  /**
   * @deprecated
   */
  public isFreeShippingCoupon: boolean;

  constructor(params: CouponDiscountModel) {
    this.isFreeShippingCoupon = params.isFreeShippingCoupon;
    this.scope = params.scope;
    this.totalAmountOff = params.totalAmountOff;
    this.targetLineItemIds = params.targetLineItemIds;
  }

  public static fromCartV1(appliedDiscounts: AppliedDiscount[], modelContext: ModelContext): CouponDiscountModel {
    const couponAlignmentInCartAndCheckout = modelContext?.viewerContext.isExperimentEnabled(
      SPECS.CouponAlignmentInCartAndCheckout
    );
    const discount = appliedDiscounts.find((appliedDiscount) => appliedDiscount?.coupon);
    const coupon = discount?.coupon;
    let scope: CouponDiscountScope | undefined;

    if (couponAlignmentInCartAndCheckout) {
      scope =
        discount?.discountType === AppliedDiscountDiscountType.SHIPPING
          ? CouponDiscountScope.DELIVERY
          : CouponDiscountScope.GLOBAL;
    }

    if (!coupon) {
      return undefined;
    }

    return new CouponDiscountModel({
      isFreeShippingCoupon: couponAlignmentInCartAndCheckout
        ? undefined
        : discount?.discountType === AppliedDiscountDiscountType.SHIPPING,
      scope,
      totalAmountOff: undefined,
      targetLineItemIds: [],
    });
  }

  public static fromCartV2(discounts?: Discount[], modelContext?: ModelContext) {
    const coupon = discounts?.find((discount) => discount.source?.sourceType === DiscountSourceType.COUPON);
    const couponAlignmentInCartAndCheckout = modelContext?.viewerContext.isExperimentEnabled(
      SPECS.CouponAlignmentInCartAndCheckout
    );

    if (!coupon) {
      return undefined;
    }

    return new CouponDiscountModel({
      isFreeShippingCoupon: couponAlignmentInCartAndCheckout ? undefined : coupon.scope === DiscountScope.DELIVERY,
      scope: couponAlignmentInCartAndCheckout ? toCouponDiscountScopeV2(coupon.scope) : undefined,
      totalAmountOff: '**$100.00**',
      targetLineItemIds: couponAlignmentInCartAndCheckout ? coupon.benefits.map((benefit) => benefit.lineItemId) : [],
    });
  }
}

export enum CouponDiscountScope {
  GLOBAL = 'GLOBAL',
  LINE_ITEM = 'LINE_ITEM',
  DELIVERY = 'DELIVERY',
}

const toCouponDiscountScopeV2 = (discountScope: DiscountScopeWithLiterals) => {
  switch (discountScope) {
    case DiscountScope.DELIVERY:
      return CouponDiscountScope.DELIVERY;
    case DiscountScope.LINE_ITEM:
      return CouponDiscountScope.LINE_ITEM;
    case DiscountScope.CART_SUBTOTAL:
    case DiscountScope.UNKNOWN_DISCOUNT_SCOPE:
      return CouponDiscountScope.GLOBAL;
  }
};
